import React from "react";

const Loading = () => {
  return <i className="fa-solid fa-spinner fa-spin loading"></i>;
};

export default Loading;
